import store from "@/store";
import AlertService from "@/helpers/AlertService";

export default {
    name: "FileService",
    data() {
    },
    fileTypesImages: fileTypesImages,
    fileTypesIcons: fileTypesIcons,
    getNames: getNames,
    readFiles: readFiles,
    checkAvailability: checkAvailability,
    computeIconByExt: computeIconByExt,
    computeImageByExt: computeImageByExt,
};

function getNames(fileList) {
    // Set names
    let names = "";
    for (let i = 0; i < fileList.length; i++) {
        names = names + fileList[i].name + ", ";
    }
    names = names.substring(0, names.length - 2);
    return names;
}

function fileTypesImages() {
    return {
        empty: "file.png",
        html: "html.png",
        js: "js.png",
        json: "json.png",
        md: "md.png",
        pdf: "pdf.png",
        png: "picture.png",
        jpg: "picture.png",
        jpeg: "picture.png",
        txt: "txt.png",
        doc: "word.png",
        docx: "word.png",
        xls: "excel.png",
        xlsx: "excel.png",
        csv: "excel.png",
        ppt: "powerpoint.png",
        pptx: "powerpoint.png",
        bat: "shell.png",
        sh: "shell.png",
        msg: "msg.png",
        mp3: "mp3.png",
        mp4: "mp4.png",
        avi: "avi.png",
    };
}

function fileTypesIcons() {
    return {
        empty: "mdi-file-outline",
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-json",
        md: "mdi-markdown",
        pdf: "mdi-file-pdf",
        png: "mdi-file-image",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        txt: "mdi-file-document-outline",
        doc: "mdi-file-word",
        docx: "mdi-file-word",
        xls: "mdi-file-excel",
        xlsx: "mdi-file-excel",
        csv: "mdi-file-excel",
        ppt: "mdi-file-powerpoint",
        pptx: "mdi-file-powerpoint",
        bat: "mdi-powershell",
        sh: "mdi-powershell",
        msg: "mdi-email",
        mp3: "mdi-file-music",
        mp4: "mdi-file-video",
        avi: "mdi-file-video",
    };
}

function checkAvailability() {
    // Check for the various File API support.
    if (window.File && window.FileReader && window.FileList && window.Blob) {
        // Great success! All the File APIs are supported.
        return true;
    } else {
        return false;
    }
}

function readFiles(evt, refId) {
    //pickedFinished=false;
    let uploadedFiles = [];
    let files = undefined;
    if (evt.target.files !== undefined) {
        console.debug("FILE.SERVICE - Read File event picked: ", evt);
        files = evt.target.files;
    } else if (evt.dataTransfer.files !== undefined) {
        console.debug("FILE.SERVICE - Read File event dropped: ", evt);
        files = evt.dataTransfer.files;
    }
    if (files === undefined) {
        // No files, throw error
        let error = "FILE.SERVICE - Read File error: No files.";
        console.error(error);
        return new Error(error);
    }
    // We have files
    console.debug("FILE.SERVICE - Read File files got from the event: ", files);
    for (let i = 0; i < files.length; i++) {
        if (files[i] !== undefined) {
            let uploadedFile = {
                name: "",
                extension: "",
                url: "",
                data: "",
                image: "",
                icon: "",
            };
            uploadedFile.name = files[i].name;
            let lastPointIndex = uploadedFile.name.lastIndexOf(".");
            if (lastPointIndex <= 0) {
                uploadedFile.extension = "empty";
            } else {
                uploadedFile.extension = (uploadedFile.name.substring(lastPointIndex + 1, uploadedFile.name.length)).toLowerCase();
            }
            let file = files[i];
            const fr = new FileReader();
            fr.readAsDataURL(file);

            fr.onerror = function (evt) {
                console.debug("FILE.SERVICE.ERROR.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
                switch (evt.target.error.code) {
                    case evt.target.error.NOT_FOUND_ERR:
                        alert("File Not Found!");
                        break;
                    /*case evt.target.error.NOT_READABLE_ERR:
                        alert('File is not readable');
                        break;*/
                    case evt.target.error.ABORT_ERR:
                        break; // noop
                    default:
                        let alertOptions = {
                            type: "error",
                            message: "An error has occurred while reading file <" + file.name + ">.",
                        };
                        AlertService.createAlert(alertOptions);
                }
            };
            fr.onabort = function (evt) {
                console.debug("FILE.SERVICE.ABORT.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
                let alertOptions = {
                    type: "info",
                    message: "File <" + file.name + "> read cancelled.",
                };
                AlertService.createAlert(alertOptions);
            };
            fr.onprogress = function (evt) {
                console.debug("FILE.SERVICE.PROGRESS.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
                if (evt.lengthComputable) {
                    let progress = Math.round((evt.loaded / evt.total) * 100);
                    console.debug("PROGRESS fileId <" + file.name + ">: ", progress);
                    let data = {
                        refId: refId,
                        name: file.name,
                        progress: progress,
                    };
                    store.dispatch("FileInputState/updateFileInLoading", data);
                }
            };
            fr.onloadstart = function (evt) {
                console.debug("FILE.SERVICE.LOADSTART.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
                let data = {
                    refId: refId,
                    name: file.name,
                    progress: 0,
                };
                store.dispatch("FileInputState/updateFileInLoading", data);
            };
            fr.onload = function (evt) {
                console.debug("FILE.SERVICE.LOAD.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
            };
            fr.onloadend = function (evt) {
                console.debug("FILE.SERVICE.LOADEND.HANDLER: - REFID: " + refId + ", FILE: ", file + ", EVT: " + evt);
                let data = {
                    refId: refId,
                    name: file.name,
                    progress: 100,
                };
                store.dispatch("FileInputState/updateFileInLoading", data);
                setTimeout(() => {
                    //console.log("NOTIFICATION.SERVICE - Timeout expired for notification with id: ", notification.id);
                    store.dispatch("FileInputState/deleteFileInLoading", data);
                }, 2000);
            };
            fr.addEventListener("load", () => {
                let fileType = file.type;
                if (fileType.split("/")[i] === "image") {
                    uploadedFile.image = fr.result;
                } else {
                    uploadedFile.image = computeImageByExt(uploadedFile.extension);
                }
                uploadedFile.icon = computeIconByExt(uploadedFile.extension);
                uploadedFile.data = file;
            });
            uploadedFiles.push(uploadedFile);
        }
    }
    console.debug("FILE.SERVICE - Read File: uploadedFiles: ", uploadedFiles);
    return uploadedFiles;
}


function computeIconByExt(extension) {
    let fileIcons = fileTypesIcons();
    let icon = fileIcons[extension];
    if (icon === undefined || icon === null || icon === "") {
        return fileIcons["empty"];
    }
    return icon;
}

function computeImageByExt(extension) {
    let fileImages = fileTypesImages();
    let image = fileImages[extension];
    if (image === undefined || image === null || image === "") {
        return fileImages["empty"];
    }
    return image;
}
